import React, {useContext} from 'react'
import PropTypes from 'prop-types'
import * as SC from './MiniCartFlyout.styled'
import AppContext from '../../context/AppContext'
import {DEVICE_TYPES, H4, H5} from '../../utils'

const MiniCartFlyout = ({showFlyout}) => {
  const {device, translations, cart} = useContext(AppContext)

  if (device !== DEVICE_TYPES.SMARTPHONE && device !== DEVICE_TYPES.PHABLET) {
    return null
  }

  const emptyCart = cart === null || cart.summary.articleCount === 0
  const articles = cart ? cart.articles : []
  const discounts = cart ? cart.discounts : []
  const fees = cart ? cart.fees : []
  const discountsAndFees = [...discounts, ...fees]

  const currency = cart ? cart.currency : 'EUR'
  const grandTotal = cart && cart.summary ? cart.summary.grandTotal : 0
  const cartLocale = cart ? cart.locale : 'de-DE'
  const locale = cartLocale.replace('_', '-')
  const currencyFormat = Intl.NumberFormat(locale, {style: 'currency', currency})

  const emptyCartHeaderText = translations.get('shop.header.minicart.flyout.empty.header')
  const emptyCartText = translations.get('shop.header.minicart.flyout.empty.text')
  const cartButtonText = translations.get('shop.header.minicart.flyout.button')
  const cartHeaderText = translations.get('shop.header.minicart.flyout.header')
  const totalText = translations.get('shop.header.minicart.flyout.total')
  const goToCart = <SC.CartLink noMargin="true" href="/checkout/overview">{cartButtonText}</SC.CartLink>

  return (
    <SC.Flyout
      aria-hidden={!showFlyout}
      showFlyout={showFlyout}
    >
      <SC.Wrapper>
        <H4>
          {emptyCart ? emptyCartHeaderText : cartHeaderText}
        </H4>

        {emptyCart
          && <>
            <p>{emptyCartText}</p>
            {goToCart}
          </>}

        {!emptyCart
          && <>

            <SC.List>
              {articles.map(article => {
                const {name, variantName, id, quantity, subtotal} = article
                const subtotalFormatted = currencyFormat.format(subtotal)
                return (
                  <SC.ListItem key={id}>
                    <SC.Column>
                      <H5>{name}</H5>
                      <div>{variantName}</div>
                    </SC.Column>
                    <SC.Column>
                      <div className="shop-header__minicart-flyout-quantity">{`${quantity} x`}</div>
                      <div>{subtotalFormatted}</div>
                    </SC.Column>
                  </SC.ListItem>
                )
              })}
            </SC.List>

            {discountsAndFees.length > 0
            && <SC.List>
              {discountsAndFees.map((item, index) => {
                const {name, subtotal} = item
                const subtotalFormatted = currencyFormat.format(subtotal)
                return (
                  <SC.ListItem key={index}>
                    <SC.Column>
                      <div>{name}</div>
                    </SC.Column>
                    <SC.Column>
                      <div>{subtotalFormatted}</div>
                    </SC.Column>
                  </SC.ListItem>
                )
              })}
            </SC.List>}

          </>}
      </SC.Wrapper>

      {!emptyCart
        && <SC.Wrapper dark>
          <SC.Row>
            <SC.Column><H5>{totalText}</H5></SC.Column>
            <SC.Column><H5>{currencyFormat.format(grandTotal)}</H5></SC.Column>
          </SC.Row>
          {goToCart}
        </SC.Wrapper>}

    </SC.Flyout>
  )
}

MiniCartFlyout.propTypes = {
  showFlyout: PropTypes.bool.isRequired
}

export default MiniCartFlyout
